import Vue from 'vue'
import VueRouter from 'vue-router'
import AboutView from '../views/AboutView.vue'
import ProductsView from '../views/ProductsView.vue'
import FaqView from '../views/FaqView.vue'
import BitcoinFaqView from '../views/BitcoinFaqView.vue'
import CartView from '../views/CartView.vue'
import OrderDetailsView from '../views/OrderDetailsView.vue'
import PaymentOptionsView from '../views/PaymentOptionsView.vue'
import OrderOverviewView from '../views/OrderOverviewView.vue'
import PaymentView from '../views/PaymentView.vue'
import OrderStatusView from '../views/OrderStatusView.vue'
import ContinuePaymentView from '../views/ContinuePaymentView.vue'

//import ContactView from '../views/ContactView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "O nas",
    meta: {
      layout: "default",
    },
    component: AboutView,
  },
  {
    path: "/produkty",
    name: "Produkty",
    meta: {
      layout: "default",
    },
    component: ProductsView,
  },
  {
    path: "/faq",
    name: "FAQ",
    meta: {
      layout: "default",
    },
    component: FaqView,
  },
  // {
  //   path: "/kontakt",
  //   name: "Kontakt",
  //   meta: {
  //     layout: "default",
  //   },
  //   component: ContactView,
  // },
  {
    path: "/bitcoin",
    name: "Jak kupić Bitcoina",
    meta: {
      layout: "default",
    },
    component: BitcoinFaqView,
  },
  {
    path: "/koszyk",
    name: "Koszyk",
    meta: {
      layout: "default",
    },
    component: CartView,
  },
  {
    path: "/zamowienie",
    name: "Zamowienie",
    meta: {
      layout: "default",
    },
    component: OrderDetailsView,
  },
  {
    path: "/opcje-platnosci",
    name: "Opcje płatności",
    meta: {
      layout: "default",
    },
    component: PaymentOptionsView,
  },
  {
    path: "/podsumowanie",
    name: "Podsumowanie",
    meta: {
      layout: "default",
    },
    component: OrderOverviewView,
  },
  {
    path: "/platnosc/:orderNumber",
    name: "Płatność",
    meta: {
      layout: "default",
    },
    component: PaymentView,
  },
  {
    path: "/status",
    name: "Status",
    meta: {
      layout: "default",
    },
    component: OrderStatusView,
  },
  {
    path: "/kontynuuj",
    name: "Kontynuuj",
    meta: {
      layout: "default",
    },
    component: ContinuePaymentView,
  },
  {
    path: "*",
    redirect: "/",
  },
]

const router = new VueRouter({
  mode: 'history',
  base: "/app",
  routes
})

export default router
